import type { CSSProperties, JSX } from "react";

export type IconName =
  | "chart"
  | "pie"
  | "sparkle"
  | "radar"
  | "trophy"
  | "flask"
  | "cpu"
  | "repeat"
  | "bell"
  | "activity"
  | "key"
  | "gear"
  | "search"
  | "chevron"
  | "chevronUp"
  | "chevronRight"
  | "plus"
  | "x"
  | "check"
  | "arrowUp"
  | "arrowDown"
  | "triUp"
  | "triDown"
  | "bolt"
  | "eye"
  | "google"
  | "lock"
  | "mail"
  | "user"
  | "filter"
  | "download"
  | "refresh"
  | "moreH"
  | "info"
  | "play";

const PATHS: Record<IconName, JSX.Element> = {
  chart: (
    <>
      <path d="M3 3v18h18" />
      <path d="M7 14l3-3 4 4 5-7" />
    </>
  ),
  pie: (
    <>
      <path d="M21 12A9 9 0 1 1 12 3v9z" />
      <path d="M21 12a9 9 0 0 0-9-9v9z" />
    </>
  ),
  sparkle: (
    <>
      <path d="M12 3l1.7 5.3L19 10l-5.3 1.7L12 17l-1.7-5.3L5 10l5.3-1.7z" />
      <path d="M19 17l.6 1.9L21.5 19.5 19.6 20l-.6 1.9-.6-1.9L16.5 19.5l1.9-.6z" />
    </>
  ),
  radar: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 12L19 5" />
      <circle cx="12" cy="12" r="4" />
    </>
  ),
  trophy: (
    <>
      <path d="M6 4h12v3a6 6 0 0 1-12 0z" />
      <path d="M6 7H3a3 3 0 0 0 3 3" />
      <path d="M18 7h3a3 3 0 0 1-3 3" />
      <path d="M9 21h6" />
      <path d="M12 13v8" />
    </>
  ),
  flask: (
    <>
      <path d="M9 3h6" />
      <path d="M10 3v7l-5 9a2 2 0 0 0 1.7 3h10.6a2 2 0 0 0 1.7-3l-5-9V3" />
    </>
  ),
  cpu: (
    <>
      <rect x="5" y="5" width="14" height="14" rx="2" />
      <rect x="9" y="9" width="6" height="6" />
      <path d="M9 1v3M15 1v3M9 20v3M15 20v3M1 9h3M1 15h3M20 9h3M20 15h3" />
    </>
  ),
  repeat: (
    <>
      <path d="M17 1l4 4-4 4" />
      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
      <path d="M7 23l-4-4 4-4" />
      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
    </>
  ),
  bell: (
    <>
      <path d="M18 8a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
      <path d="M13.7 21a2 2 0 0 1-3.4 0" />
    </>
  ),
  activity: <path d="M22 12h-4l-3 9L9 3l-3 9H2" />,
  key: (
    <>
      <circle cx="8" cy="15" r="4" />
      <path d="M11 12l9-9" />
      <path d="M16 7l3 3" />
      <path d="M18 5l3 3" />
    </>
  ),
  gear: (
    <>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.65 1.65 0 0 0-1.8-.3 1.65 1.65 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.65 1.65 0 0 0-1-1.5 1.65 1.65 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.65 1.65 0 0 0 .3-1.8 1.65 1.65 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.65 1.65 0 0 0 1.5-1 1.65 1.65 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.65 1.65 0 0 0 1.8.3H9a1.65 1.65 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.65 1.65 0 0 0 1 1.5 1.65 1.65 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.65 1.65 0 0 0-.3 1.8V9a1.65 1.65 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.65 1.65 0 0 0-1.5 1z" />
    </>
  ),
  search: (
    <>
      <circle cx="11" cy="11" r="7" />
      <path d="M21 21l-4.3-4.3" />
    </>
  ),
  chevron: <path d="M6 9l6 6 6-6" />,
  chevronUp: <path d="M18 15l-6-6-6 6" />,
  chevronRight: <path d="M9 6l6 6-6 6" />,
  plus: <path d="M12 5v14M5 12h14" />,
  x: <path d="M18 6L6 18M6 6l12 12" />,
  check: <path d="M20 6L9 17l-5-5" />,
  arrowUp: <path d="M12 19V5M5 12l7-7 7 7" />,
  arrowDown: <path d="M12 5v14M5 12l7 7 7-7" />,
  triUp: <path d="M12 5l8 14H4z" />,
  triDown: <path d="M12 19l-8-14h16z" />,
  bolt: <path d="M13 2L3 14h7l-1 8 10-12h-7z" />,
  eye: (
    <>
      <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z" />
      <circle cx="12" cy="12" r="3" />
    </>
  ),
  google: (
    <>
      <path d="M21.6 11.1c0-.7-.1-1.4-.2-2.1H12v4h5.4a4.6 4.6 0 0 1-2 3v2.5h3.2c1.9-1.7 3-4.3 3-7.4z" fill="#4285F4" stroke="none" />
      <path d="M12 22c2.7 0 5-1 6.6-2.5l-3.2-2.5a6 6 0 0 1-9-3.2H3v2.6A10 10 0 0 0 12 22z" fill="#34A853" stroke="none" />
      <path d="M6.4 13.8a6 6 0 0 1 0-3.7V7.5H3a10 10 0 0 0 0 9z" fill="#FBBC05" stroke="none" />
      <path d="M12 6a5.4 5.4 0 0 1 3.8 1.5L18.6 4.7A10 10 0 0 0 3 7.5l3.4 2.6A6 6 0 0 1 12 6z" fill="#EA4335" stroke="none" />
    </>
  ),
  lock: (
    <>
      <rect x="4" y="11" width="16" height="10" rx="2" />
      <path d="M8 11V7a4 4 0 0 1 8 0v4" />
    </>
  ),
  mail: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M3 7l9 6 9-6" />
    </>
  ),
  user: (
    <>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21a8 8 0 0 1 16 0" />
    </>
  ),
  filter: <path d="M3 4h18l-7 9v6l-4-2v-4z" />,
  download: (
    <>
      <path d="M12 3v12m-5-5l5 5 5-5" />
      <path d="M5 21h14" />
    </>
  ),
  refresh: (
    <>
      <path d="M3 12a9 9 0 0 1 15-6.7L21 8" />
      <path d="M21 3v5h-5" />
      <path d="M21 12a9 9 0 0 1-15 6.7L3 16" />
      <path d="M3 21v-5h5" />
    </>
  ),
  moreH: (
    <>
      <circle cx="5" cy="12" r="1.5" />
      <circle cx="12" cy="12" r="1.5" />
      <circle cx="19" cy="12" r="1.5" />
    </>
  ),
  info: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 8v0M12 12v5" />
    </>
  ),
  play: <path d="M5 3l14 9-14 9z" />,
};

interface IconProps {
  name: IconName;
  size?: number;
  className?: string;
  style?: CSSProperties;
}

export function Icon({ name, size = 16, className = "", style }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={style}
    >
      {PATHS[name]}
    </svg>
  );
}
